// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/quote.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcceptCounterOfferRequest, AcceptQuoteRequest, BatchResearchQuoteReviewsRequest, BatchResearchQuoteReviewsResponse, BatchReviewQuoteReviewsRequest, BatchReviewQuoteReviewsResponse, ConvertQuoteToOrderRequest, ConvertQuoteToOrderResponse, CreateQuoteRequest, DeleteQuoteRequest, FinalizeQuoteRequest, FinalizeQuoteResponse, GetQuoteRequest, ListQuoteReviewsRequest, ListQuoteReviewsResponse, ListQuotesRequest, ListQuotesResponse, ProcessQuoteRequest, Quote, RejectQuoteRequest, ReviewQuoteReviewRequest, ReviewQuoteReviewResponse, SearchQuoteReviewAlternativesRequest, SendQuoteRequest, SetQuoteLinesRequest, SetQuoteLinesResponse, SubmitCounterOfferRequest, UpdateQuoteRequest } from "./quote_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { ProcessOrderUpdate, SearchAlternativesResponse } from "./work_item_pb.js";

/**
 * @generated from service omnios.v1.QuoteService
 */
export const QuoteService = {
  typeName: "omnios.v1.QuoteService",
  methods: {
    /**
     * CRUD
     *
     * @generated from rpc omnios.v1.QuoteService.CreateQuote
     */
    createQuote: {
      name: "CreateQuote",
      I: CreateQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.GetQuote
     */
    getQuote: {
      name: "GetQuote",
      I: GetQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.UpdateQuote
     */
    updateQuote: {
      name: "UpdateQuote",
      I: UpdateQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.DeleteQuote
     */
    deleteQuote: {
      name: "DeleteQuote",
      I: DeleteQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.ListQuotes
     */
    listQuotes: {
      name: "ListQuotes",
      I: ListQuotesRequest,
      O: ListQuotesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Line management
     *
     * @generated from rpc omnios.v1.QuoteService.SetQuoteLines
     */
    setQuoteLines: {
      name: "SetQuoteLines",
      I: SetQuoteLinesRequest,
      O: SetQuoteLinesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lifecycle
     *
     * @generated from rpc omnios.v1.QuoteService.SendQuote
     */
    sendQuote: {
      name: "SendQuote",
      I: SendQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.AcceptQuote
     */
    acceptQuote: {
      name: "AcceptQuote",
      I: AcceptQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.RejectQuote
     */
    rejectQuote: {
      name: "RejectQuote",
      I: RejectQuoteRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.SubmitCounterOffer
     */
    submitCounterOffer: {
      name: "SubmitCounterOffer",
      I: SubmitCounterOfferRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.AcceptCounterOffer
     */
    acceptCounterOffer: {
      name: "AcceptCounterOffer",
      I: AcceptCounterOfferRequest,
      O: Quote,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.ConvertQuoteToOrder
     */
    convertQuoteToOrder: {
      name: "ConvertQuoteToOrder",
      I: ConvertQuoteToOrderRequest,
      O: ConvertQuoteToOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * PO extraction + review (quote-centric, replaces ProcessPurchaseOrder)
     *
     * @generated from rpc omnios.v1.QuoteService.ProcessQuote
     */
    processQuote: {
      name: "ProcessQuote",
      I: ProcessQuoteRequest,
      O: ProcessOrderUpdate,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.ListQuoteReviews
     */
    listQuoteReviews: {
      name: "ListQuoteReviews",
      I: ListQuoteReviewsRequest,
      O: ListQuoteReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.ReviewQuoteReview
     */
    reviewQuoteReview: {
      name: "ReviewQuoteReview",
      I: ReviewQuoteReviewRequest,
      O: ReviewQuoteReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.BatchReviewQuoteReviews
     */
    batchReviewQuoteReviews: {
      name: "BatchReviewQuoteReviews",
      I: BatchReviewQuoteReviewsRequest,
      O: BatchReviewQuoteReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.BatchResearchQuoteReviews
     */
    batchResearchQuoteReviews: {
      name: "BatchResearchQuoteReviews",
      I: BatchResearchQuoteReviewsRequest,
      O: BatchResearchQuoteReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.SearchQuoteReviewAlternatives
     */
    searchQuoteReviewAlternatives: {
      name: "SearchQuoteReviewAlternatives",
      I: SearchQuoteReviewAlternativesRequest,
      O: SearchAlternativesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.QuoteService.FinalizeQuote
     */
    finalizeQuote: {
      name: "FinalizeQuote",
      I: FinalizeQuoteRequest,
      O: FinalizeQuoteResponse,
      kind: MethodKind.Unary,
    },
  }
};

